import React from 'react'
import classNames from 'classnames'

const CardFooter = props => {
  return (
    <div className={classNames('card_footer', props.className)}>
      {props.children}
    </div>
  )
}

export default CardFooter
